import { render } from "./UpdateExtension.vue?vue&type=template&id=096cbc82&scoped=true"
import script from "./UpdateExtension.vue?vue&type=script&lang=js"
export * from "./UpdateExtension.vue?vue&type=script&lang=js"

import "./UpdateExtension.vue?vue&type=style&index=0&id=096cbc82&scoped=true&lang=less"

import exportComponent from "/build/cloudstack-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-096cbc82"]])

export default __exports__